import StageAreaChart from './StageAreaChart';
import { type Snapshot } from './helpers';

/** Per-stage execution rate with the total queued backlog on a secondary axis. */
export default function ThroughputChart({ history }: { history: Snapshot[] }) {
  return (
    <StageAreaChart
      history={history}
      getValue={(stage) => stage.ratePerMin}
      yTitle="tasks/min"
      secondary={{
        label: 'Total backlog',
        axisTitle: 'queued',
        getTotal: (snapshot) => snapshot.stages.reduce((acc, stage) => acc + stage.queueDepth, 0),
      }}
    />
  );
}
